export const GOHONZON_TABLES_MAP = {
  GOHONZON_APPLY: "GOHONZON_APPLY",
  APPLICATION_VERIFICATION: "APPLICATION_VERIFICATION",
  GOHONZON_RETURN_VERIFICATION: "GOHONZON_RETURN_VERIFICATION",
  GOHONZON_REPLACEMENT_VERIFICATION: "GOHONZON_REPLACEMENT_VERIFICATION",
  GOHONZON_INTERVIEW: "GOHONZON_INTERVIEW",
  GOHONZON_APPLICATIONS: "GOHONZON_APPLICATIONS",
  GOHONZON_VERIFICATION: "GOHONZON_VERIFICATION",
  GOHONZON_BATCH_ALLOTMENT: "GOHONZON_BATCH_ALLOTMENT",
  GOHONZON_BATCH_HISTORY: "GOHONZON_BATCH_HISTORY",
  GOHONZON_ALLOTMENT: "GOHONZON_ALLOTMENT",
  GOHONZON_BATCH_VIEW: "GOHONZON_BATCH_VIEW",
  ALLOTMENT_HISTORY: "ALLOTMENT_HISTORY",
  GOHONZON_HANDOVER: "GOHONZON_HANDOVER",
  GOHONZON_BATCH_CONFERRAL: "GOHONZON_BATCH_CONFERRAL",
  GOHONZON_CONFERRAL: "GOHONZON_CONFERRAL",
  GOHONZON_CANCEL_REQUEST: "GOHONZON_CANCEL_REQUEST",
  GOHONZON_APPROVAL: "GOHONZON_APPROVAL",
  GOHONZON_RETURNED_HANDOVER: "GOHONZON_RETURNED_HANDOVER",
  GOHONZON_RETURN_REQUEST: "GOHONZON_RETURN_REQUEST",
  GOHONZON_OMAMORI_CONFERRAL: "GOHONZON_OMAMORI_CONFERRAL",
  GOHONZON_REPLACEMENT_CONFERRAL: "GOHONZON_REPLACEMENT_CONFERRAL",
  GOHONZON_OMAMORI_ALLOTMENT: "GOHONZON_OMAMORI_ALLOTMENT",
  GOHONZON_OMAMORI_HANDOVER: "GOHONZON_OMAMORI_HANDOVER",
  GOHONZON_TRACKING: "GOHONZON_TRACKING",
};

export const PREVIEW = "preview";

export const GOHONZON_FORM_TYPE = {
  APPLICATION: "APPLICATION",
  REPLACEMENT: "REPLACEMENT",
  RETURN: "RETURN",
};

export const returnGohonzonQuestions = [
  {
    questionId: 1,
    name: "radio-1",
    questionType: "CHECKBOX",
    answerType: "boolean",
    key: "marriageWithGohonzonMember",
    ques: "MARRIAGE WITH GOHONZON MEMBER",
  },
  {
    questionId: 5,
    name: "radio-5",
    questionType: "CHECKBOX",
    answerType: "boolean",
    key: "notPracticing",
    ques: "NOT PRACTICING",
  },
  {
    questionId: 2,
    name: "radio-2",
    questionType: "CHECKBOX",
    answerType: "boolean",
    key: "startedLivingWithTheFamilyAlreadyHavingGohonzon",
    ques: "STARTED LIVING WITH THE FAMILY ALREADY HAVING GOHONZON",
  },
  {
    questionId: 6,
    name: "radio-6",
    questionType: "CHECKBOX",
    answerType: "boolean",
    key: "gohonzonDamagedByMemberHimselfOrHerself",
    ques: "GOHONZON DAMAGED BY MEMBER HIMSELF OR HERSELF",
  },
  {
    questionId: 3,
    name: "radio-3",
    questionType: "CHECKBOX",
    answerType: "boolean",
    key: "demise",
    ques: "DEMISE",
  },
  {
    questionId: 7,
    name: "radio-7",
    questionType: "CHECKBOX",
    answerType: "boolean",
    key: "gohonzonDamagedByFamilyMember",
    ques: "GOHONZON DAMAGED BY FAMILY MEMBER",
  },
  {
    questionId: 4,
    name: "radio-4",
    questionType: "CHECKBOX",
    answerType: "boolean",
    key: "exchangingOldGohonzon",
    ques: "EXCHANGING OLD GOHONZON",
  },
  {
    questionId: 8,
    name: "radio-8",
    questionType: "TEXTFIELD",
    answerType: "string",
    key: "other",
    ques: "OTHER",
  },
];

export const okatakiGohonzonQuestionsForMember = [
  {
    questionId: 1,
    name: "radio-1",
    questionType: "DROPDOWN",
    ques: "DURATION OF PRACTICE (Minimum 6 Months)",
    answerType: "integer",
    key: "durationOfPractice",
  },
  {
    questionId: 2,
    name: "radio-2",
    ques: "DOING REGULAR GONGYO & DAIMOKU ",
    answerType: "boolean",
    key: "regularGongyoDaimoku",
  },
  {
    questionId: 3,
    name: "radio-3",
    ques: "PERMISSION TO RECEIVE AND ENSHRINE THE GOHONZON FROM FAMILY ",
    answerType: "boolean",
    key: "permissionToReceive",
  },
];

export const okatakiGohonzonQuestions = [
  {
    questionId: 1,
    name: "radio-1",
    questionType: "DROPDOWN",
    ques: "DURATION OF PRACTICE (Minimum 6 Months)",
    answerType: "integer",
    key: "durationOfPractice",
  },
  {
    questionId: 2,
    name: "radio-2",
    ques: "DOING REGULAR GONGYO & DAIMOKU ",
    answerType: "boolean",
    key: "regularGongyoDaimoku",
  },
  {
    questionId: 3,
    name: "radio-3",
    ques: "PERMISSION TO RECEIVE AND ENSHRINE THE GOHONZON FROM FAMILY ",
    answerType: "boolean",
    key: "permissionToReceive",
  },
  {
    questionId: 4,
    name: "radio-4",
    questionType: "PROPOSED",
    ques: "PROPOSED PLACE FOR ENSHRINING GOHONZON",
    answerType: "boolean",
    key: "placeOfEnshrined",
  },
];
export const appointmentModalQuestions = [
  {
    name: "radio-1",
    ques: "DID THE COMMITTEE",
    key: "didTheCommitteeMeet",
  },
  {
    name: "radio-2",
    ques: "DID YOU PRACTICING",
    key: "didYouParticipate",
  },
  {
    name: "radio-3",
    ques: "DO YOU APPROVE THE APPOINTMENT",
    key: "doYouApproveTheAppointment",
  },
];
